/** Home "Pass gratuité" promo (Figma 01): its dismiss is kept on this device only. */
type Store = Pick<Storage, "getItem" | "setItem">;
const KEY = "home-promo-dismissed";

const storage = (): Store | undefined => {
  try {
    return globalThis.localStorage;
  } catch {
    return undefined;
  }
};

export function promoDismissed(store: Store | undefined = storage()): boolean {
  try {
    return store?.getItem(KEY) === "1";
  } catch {
    return false; // private mode / blocked storage: show it
  }
}

export function dismissPromo(store: Store | undefined = storage()): void {
  try {
    store?.setItem(KEY, "1");
  } catch {
    // blocked storage: dismissed for this visit only
  }
}
